
export function setCurrentAccount(userId: any){
  if(userId){
    localStorage.setItem('currentAccountId', `${userId}`);
  }else {
    localStorage.removeItem('currentAccountId');
  }
}

export function getCurrentAccount(){
  return localStorage.getItem('currentAccountId');
}
